import script from "./NavigationMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&setup=true&lang=js"

import "./NavigationMenu.vue?vue&type=style&index=0&id=58708d64&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58708d64"]])

export default __exports__